import React from 'react';

/**
 * Kompakte Kennzahlen-Kacheln.
 *
 * @param {{label: string, value: React.ReactNode, hint?: string, pending?: boolean}[]} items
 */
export default function StatGrid({ items }) {
    return (
        <dl className="stat-grid">
            {items.map((item) => (
                <div key={item.label} className={`stat${item.pending ? ' stat-pending' : ''}`}>
                    <dt>{item.label}</dt>
                    <dd>{item.pending ? 'in Bearbeitung' : item.value}</dd>
                    {item.hint && <span className="stat-hint">{item.hint}</span>}
                </div>
            ))}
        </dl>
    );
}
